import React from "react";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
	partialCircle: {
		width: "100%",
		height: "100%",
	}
});

type PartialCircleProps = {
	size: number
	percentage: number
	thickness: number
	color: string
}

export default function PartialCircle({size, percentage, thickness, color}:PartialCircleProps) {
	const classes = useStyles();

	if(percentage === 0) {
		return <></>;
	} else {
		const d = describeArc(size/2,size/2,(size-thickness)/2, 0, percentage * 360);
		return (
			<svg className={classes.partialCircle}>
				<path fill="none" stroke={color} strokeWidth={thickness} d={d}/>
			</svg>
		);
	}

}

//https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle

function describeArc(x:number, y:number, radius:number, startAngle:number, endAngle:number) {
	const fullCircle = (endAngle - startAngle) === 360;
	const start = polarToCartesian(x, y, radius, endAngle-0.01);
	const end = polarToCartesian(x, y, radius, startAngle);

	const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

	const d = [
		"M", start.x, start.y,
		"A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
	];
	if(fullCircle) {
		d.push("z");
	}

	return d.join(" ");
}



function polarToCartesian(centerX:number, centerY:number, radius:number, angleInDegrees:number) {
	const angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

	return {
		x: centerX + (radius * Math.cos(angleInRadians)),
		y: centerY + (radius * Math.sin(angleInRadians))
	};
}